import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-projectsSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-projectsSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 20,
				slideClass: 'b-projectsSlider-item',
				loop: false,
				watchOverflow: true,
			});
		});
	});
});
